(ns ui.view.survey.modals.event
  (:require [ajax.core :as ajax]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [ui.view.survey.modals.sub :as sub]
            [ui.view.survey.sub :as survey-view-sub]))

(rf/reg-event-fx
 ::open-remove-column-modal
 (fn [{db :db} [_ survey-id max-saved-index]]
   {:db (assoc db ::sub/remove-modal-open? true
                  ::sub/survey-id survey-id
                  ::sub/remove-index max-saved-index)}))

(rf/reg-event-fx
 ::close-remove-column-modal
 (fn [{db :db} [_]]
   {:db (assoc db ::sub/remove-modal-open? false)}))

(rf/reg-event-fx
 ::open-submit-modal
 (fn [{db :db} [_ survey-id]]
   {:db (-> db
            (assoc ::sub/submit-modal-open? true)
            (assoc ::sub/survey-id survey-id))}))

(rf/reg-event-fx
 ::close-submit-modal
 (fn [{db :db} [_]]
   {:db (assoc db ::sub/submit-modal-open? false)}))

(rf/reg-event-fx
 ::hide-resolve-errors-warning
 (fn [{db :db} [_]]
   {:db (assoc db ::sub/show-resolve-errors-warning? false)}))

(rf/reg-event-fx
 ::toggle-show-rows-without-errors
 (fn [{db :db} [_ checked?]]
   {:db (assoc db ::sub/show-rows-without-errors? checked?)}))

(rf/reg-event-fx
 ::toggle-show-columns-without-errors
 (fn [{db :db} [_ checked?]]
   {:db (assoc db ::sub/show-columns-without-errors? checked?)}))

(rf/reg-event-fx
 ::set-selected-sheets
 (fn [{db :db} [_ survey-id value]]
   {:db (assoc-in db [::survey-view-sub/selected-sheets survey-id] value)}))

(rf/reg-event-fx
 ::close-num-fmt-modal
 (fn [{db :db} [_]]
   {:db (assoc db ::sub/num-fmt-modal-open? false)}))

(rf/reg-event-fx
 ::close-missing-modal
 (fn [{db :db} [_]]
   {:db (assoc db ::sub/missing-modal-open? false)}))

(rf/reg-event-fx
 ::save-num-format-in-ls
 (fn [{db :db} [_ v]]
   {:db (assoc db ::sub/save-num-format-in-ls v)}))

(rf/reg-event-fx
 ::delete-last-series-ok
 (fn [{db :db} [_ survey-id series-index]]
   {:db (-> db
            (dissoc ::survey-view-sub/deleting-column?)
            (dissoc ::sub/remove-modal-open?)
            (update-in [::survey-view-sub/saved-answer-series survey-id]
                       (fn [series]
                         (if-not (map? series)
                           series
                           (->> series
                                (remove (fn [[k m]]
                                          (= k series-index)))
                                (into {})))))
            (update-in [::survey-view-sub/unsaved-answer-series survey-id]
                       (fn [series]
                         (if-not (map? series)
                           series
                           (->> series
                                (remove (fn [[k m]]
                                          (= k series-index)))
                                (into {}))))))}))

(rf/reg-event-fx
 ::delete-last-series-failed
 (fn [{db :db} [_ err]]
   {:db (-> db
            (dissoc ::sub/deleting-column?))}))

(rf/reg-event-fx
 ::delete-last-series
 (fn [{db :db} [_]]
   (let [survey-id (get db ::sub/survey-id)
         max-saved-index (get db ::sub/remove-index)
         last-updated-on (get-in db [::survey-view-sub/survey-processes-last-updated-on survey-id])]
     (when (pos? max-saved-index)
       {:db         (-> db
                        (assoc-in [::sub/deleting-column? survey-id] true))

        :http-xhrio {:method          :post
                     :uri             "/surveys/api/delete-response-series"
                     :params          {:process-id      survey-id
                                       :series-index    max-saved-index
                                       :last-updated-on last-updated-on}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::delete-last-series-ok survey-id max-saved-index]
                     :on-failure      [::delete-last-series-failed survey-id]}}))))

(rf/reg-event-fx
 ::on-submit-wip-ok
 (fn [{db :db} [_ survey-id answers resp]]
   {:db (-> db
            (assoc-in [::survey-view-sub/saved-answers survey-id] answers)
            (assoc-in [::survey-view-sub/submitted? survey-id] true)
            (dissoc [::sub/submit-modal-open?]))}))

(rf/reg-event-fx
 ::on-submit-wip-failed
 (fn [{db :db} [_]]
   {}))

(rf/reg-event-fx
 ::submit
 (fn [{db :db} [_ survey-id]]
   (let [saved-answers (get-in db [::survey-view-sub/saved-answer-series survey-id] {})
         unsaved-answers (get-in db [::survey-view-sub/unsaved-answer-series survey-id] {})
         answers (potpuri/deep-merge saved-answers unsaved-answers)]
     {:db         (assoc db ::sub/submit-modal-open? false)
      :http-xhrio {:method          :post
                   :uri             "/surveys/api/submit-process-wip-quest"
                   :params          {:process-id survey-id}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::on-submit-wip-ok survey-id answers]
                   :on-failure      [::on-submit-wip-failed]}})))
